module.exports = ".errorInput {\r\n    border: 1px solid #dd2d2d;\r\n}"